import { ReactNode } from 'react';
import { alpha, Theme, SxProps } from '@mui/material/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RemoveIcon from '@mui/icons-material/Remove';
import type { ImportRowStatus } from './types';

interface StatusVisual {
  icon: ReactNode;
  tooltip: string;
  rowSx?: SxProps<Theme>;
}

const baseIconSx = { fontSize: 20 };

export function getStatusVisual(status: ImportRowStatus): StatusVisual {
  switch (status) {
    case 'ready':
      return {
        icon: <CheckCircleOutlineIcon sx={{ ...baseIconSx, color: 'success.main' }} />,
        tooltip: 'Lista para importar',
      };
    case 'needs_review':
      return {
        icon: <WarningAmberIcon sx={{ ...baseIconSx, color: 'warning.main' }} />,
        tooltip: 'Revisar antes de importar',
        rowSx: { bgcolor: 'warning.50' },
      };
    case 'blocked':
      return {
        icon: <ErrorOutlineIcon sx={{ ...baseIconSx, color: 'error.main' }} />,
        tooltip: 'No importable: resuelve el error',
        rowSx: {
          bgcolor: (theme: Theme) => alpha(theme.palette.error.main, 0.08),
        },
      };
    case 'possible_duplicate':
      return {
        icon: <ContentCopyIcon sx={{ ...baseIconSx, color: 'accent.main' }} />,
        tooltip: 'Posible duplicado de una transacción existente',
      };
    case 'skipped':
      return {
        icon: <RemoveIcon sx={{ ...baseIconSx, color: 'text.disabled' }} />,
        tooltip: 'Omitida — no se importará',
        rowSx: { opacity: 0.5 },
      };
  }
}
